const CLIENTS = [
  { name: "Muthoot Finance", logo: "/logos/muthoot.png" },
  { name: "Manappuram Finance", logo: "/logos/manappuram.png" },
  { name: "Ashirwad Gold Finance", logo: "/logos/ashirwad.png" },
  { name: "IIFL Finance", logo: "/logos/iifl.png" },
  { name: "HDFC Bank", logo: "/logos/hdfc.png" },
  { name: "Helios — The Watch Store", logo: "/logos/helios.png" },
  { name: "Titan Eye+", logo: "/logos/titan-eye.png" },
  { name: "Apollo Pharmacy", logo: "/logos/apollo.png" },
  { name: "Lenskart", logo: "/logos/lenskart.png" },
  { name: "D-Mart", logo: "/logos/dmart.png" },
  { name: "Big Bazaar", logo: "/logos/big-bazaar.png" },
  { name: "MedPlus", logo: "/logos/medplus.png" },
  { name: "Beltone", logo: "/logos/beltone.png" },
  { name: "Reliance Mutual Fund", logo: "/logos/reliance.png" },
];

export default function ClientsMarquee({ slim = false }) {
  return (
    <section className={`clients-section ${slim ? "clients-slim" : ""}`} data-testid={slim ? "home-clients" : "leasing-clients"}>
      {slim ? (
        <p className="clients-slim-label" data-testid="home-clients-label">Trusted by India&apos;s most recognised brands</p>
      ) : (
        <div className="section-wrap clients-head">
          <p className="eyebrow">IN GOOD COMPANY</p>
          <h2>Trusted by brands<br /><em>you already know.</em></h2>
          <p className="clients-sub">Two decades of commercial leasing for India's most recognised names — and several other corporate clients.</p>
        </div>
      )}
      <div className="clients-marquee">
        <div className="clients-track">
          {[...CLIENTS, ...CLIENTS].map((client, index) => (
            <span className="client-chip" key={`${client.name}-${index}`} data-testid={index < CLIENTS.length ? `client-chip-${index}` : undefined}>
              {client.logo ? <img className="client-logo" src={client.logo} alt={client.name} /> : client.name}<i className="client-dot">◆</i>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
